<template>
  <div>
    <div class="subcription-text mt-8">
      <span
        v-html="
          recurring
            ? tierPlan.plan.interval === 'MONTHLY'
              ? $t('payment.sub_renew_month')
              : $t('payment.sub_renew_year')
            : tierPlan.plan.interval === 'MONTHLY'
              ? $t('payment.manual_sub_month')
              : $t('payment.manual_sub_year')
        "
      />
      {{ ' ' }}
      <span
        v-html="
          $t(recurring ? 'payment.you_will_be_charged' : 'payment.manual_will_be_charged', {
            amount: `${tierPlan.next_year_price || tierPlan.next_month_price} USD`,
          })
        "
      />
    </div>
    <div class="subcription-text mt-2">
      {{ termsText }}
      <a
        target="_blank"
        :href="termsUrl"
        class="terms"
      >
        {{ $t('payment.terms_service') }}</a
      >.
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionText',
  props: {
    tierPlan: {
      type: Object,
      required: true,
    },
    termsText: {
      type: String,
      required: true,
    },
    termsUrl: {
      type: String,
      required: true,
    },
    recurring: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.subcription-text {
  font-size: 12px;
  color: var(--app-clr-grey-2);
}
.terms {
  text-decoration: underline !important;
  color: var(--app-clr-grey-2);
}
</style>
